export const LOGO_URL =
  "/logo.png";

export const CONTACT = {
  phoneDisplay: "0212 803 30 23",
  phoneE164: "+902128033023",
  whatsappUrl: "https://wa.me/902128033023?text=Merhaba%2C%20AjansBilir%20web%20sitenizden%20ula%C5%9F%C4%B1yorum.",
  phoneLink: "tel:+902128033023",
  email: "info@ajansbilir.com",
  emailLink: "mailto:info@ajansbilir.com",
  address: "İstanbul, Beylikdüzü",
  social: {
    instagram: "#",
    facebook: "#",
    linkedin: "#",
  },
};

export const NAV_LINKS = [
  { id: "anasayfa", label: "Ana Sayfa" },
  { id: "hizmetler", label: "Hizmetler" },
  { id: "portfoy", label: "Portföy" },
  { id: "hakkimizda", label: "Hakkımızda" },
  { id: "fiyatlandirma", label: "Fiyatlandırma" },
  { id: "blog", label: "Blog" },
  { id: "iletisim", label: "İletişim" },
];
